<!--
Listagem do cadastro de grupos de tributacao e regras de impostos (tabela grutrib / regraimp / grutribncm)
-->

<script>
import BarList from '../components/bar-list'
import BarGrid from '../components/bar-grid'
import RegraimpForm from './regraimp-form'
import { SysVars } from '../main';

export default {
    data () {
        return {
            showForm: false, //exibe a tela de manutencao
            codgrutrib: null,
        }
    },

    computed: {
        metadata: function () {
            return this.$store.getters.getEntities.metadata
        },
        regraList: function () {
            return this.$store.getters.getRegraimpList
        },
        grutribList: function () {
            return this.$store.getters.getGrutribList
        },
        empty: function () {
            return !this.regraList || this.regraList.length == 0
        },

    },

    methods: {
        handleEdit (codgrutrib) {
            //abre a tela de edicao
            this.crud = SysVars.crudU
            this.codgrutrib = codgrutrib
            this.showForm = true
        },

        handleIncluir () {
            //abre a tela de inclusao
            this.crud = SysVars.crudI
            this.showForm = true;
        },

        closeForm () {
            this.showForm = false
            this.loadData()
        },

        search (value) {
            //efetua a pesquisa
            this.filter = '{"descricao":{"$like":"' + value + '%25"}}'
            this.loadData()
        },

        async loadData () {
            await this.$store.dispatch('loadGrutribList', { filter: this.filter } )
            if (this.regraList.length == 0) {
                this.empty = true
            } else {
                this.empty = false
            }
        },

        textFinalidade (value) {
            if (this.metadata) {
              var item = this.metadata.regraimp.finalidade.options.filter(x => x.id === value);
              if (item.length) { return item[0].text }
            } else { return value }
        },
    },

    components: {
        BarList, BarGrid, RegraimpForm
    },

    mounted() {
    },

    beforeDestroy() {
    },

    created () {
        this.showForm = false
        this.loadData()
    }
}

</script>

<template>
    <div id="grid">
        <div id="list" v-show="!showForm">

            <bar-list
                :refresh-button="true"
                :new-button="true"
                single-entity="Grupo de Regra de Imposto"
                plural-entity="Grupos de Regras de Impostos"
                v-on:search="search"
                v-on:new="handleIncluir"
                v-on:refresh="loadData()"
                title-search="Pesquise pela descrição do grupo">
            </bar-list>

            <br>
            <div class="default-container nb-card-list">
                <alert v-if="empty" type="warning" text="Nenhuma regra foi encontrada."></alert>

                <article class="nb-card" v-for="(grutrib, index) in grutribList" :key="grutrib.codgrutrib || index">
                    <div class="nb-card-top">
                        <div class="nb-card-identity">
                            <div class="nb-card-icon">
                                <i class="fa fa-percent" aria-hidden="true"></i>
                            </div>
                            <div class="nb-card-title">
                                <div class="nb-card-title-line">
                                    <h2>{{ grutrib.descricao }}</h2>
                                    <span v-if="grutrib.regra_geral == 'S'" class="nb-card-badge nb-card-badge--neutral">
                                        Regra Geral
                                    </span>
                                </div>
                                <div class="nb-card-code" v-if="grutrib.codgrutrib">
                                    Código <strong>{{ grutrib.codgrutrib }}</strong>
                                </div>
                            </div>
                        </div>

                        <div class="nb-card-actions">
                            <bar-grid
                                :options="{barDefault: true, btnView: true, btnEdit: true, btnEditLabel: 'Editar'}"
                                :moreActions="[]"
                                v-on:edit="handleEdit(grutrib.codgrutrib)"
                                v-on:view="handleEdit(grutrib.codgrutrib)">
                            </bar-grid>
                        </div>
                    </div>
                </article>
            </div>

        </div>

        <regraimp-form v-if="showForm" :crud="crud" :codgrutrib="codgrutrib" v-on:closeform="closeForm"></regraimp-form>

    </div>
</template>

<style scoped>
.default-container.nb-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0;
  background: transparent;
  border: 0;
  box-shadow: none;
}

.nb-card {
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.04);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.nb-card:hover {
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
}

.nb-card-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.nb-card-identity {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  gap: 12px;
}

.nb-card-icon {
  display: flex;
  flex: 0 0 48px;
  width: 48px;
  height: 48px;
  align-items: center;
  justify-content: center;
  color: #004e94;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  font-size: 19px;
}

.nb-card-title {
  flex: 1;
  min-width: 0;
}

.nb-card-title-line {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 9px;
}

.nb-card-title-line h2 {
  min-width: 0;
  margin: 0;
  color: #0b1c30;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.35;
  overflow-wrap: anywhere;
}

.nb-card-code {
  margin-top: 3px;
  color: #64748b;
  font-size: 12px;
}

.nb-card-code strong {
  color: #334155;
  font-weight: 600;
}

.nb-card-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 4px 7px;
  border: 1px solid transparent;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
}

.nb-card-badge--neutral {
  color: #475569;
  background: #f1f5f9;
  border-color: #e2e8f0;
}

.nb-card-actions {
  flex: 0 0 auto;
}

@media (max-width: 767.98px) {
  .nb-card-top {
    align-items: flex-start;
    flex-direction: column;
  }

  .nb-card-actions {
    align-self: flex-end;
  }
}
</style>



// WEBPACK FOOTER //
// src/forms/regraimp-list.vue